import { render, staticRenderFns } from "./surface_title.vue?vue&type=template&id=c83a7a92&scoped=true&"
import script from "./surface_title.vue?vue&type=script&lang=ts&"
export * from "./surface_title.vue?vue&type=script&lang=ts&"
import style0 from "./surface_title.vue?vue&type=style&index=0&id=c83a7a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83a7a92",
  null
  
)

export default component.exports